export default {
  WELCOME_YOU: '欢迎您',
  LOGIN_AND_REGISTRATION: '登录/注册',
  PLEASE_LOGIN: '请登录',
  LICENSE_INFORMATION: '证照信息',
  ICP_INFO: '京ICP备11014788 号-5A',
  ABOUT_AMAZON: '关于亚马逊海外购App',
  COMMENTED: '已评价',
  TO_EVALUATE: '去评价',
  APPLICATION_MARKET_OPERATE: '请到应用市场进行升级，评价操作',
  CURRENT_VERSION: '当前版本',
  AD_PREFERENCES: '广告偏好设置',
  PERS_REC: '个性化内容推荐',
  ALLOW_PERS_REC: '允许提供个性化推荐内容，提升您的浏览和购物体验',
  MANAGE_AUTH: '管理我的授权',
  GS_PAPER_AND_ORDER_AUTH: '海外购告知书及下单授权',
  AUTH_FOR_BETTER_EXPERIENCE:
    '为了更好地体验由亚马逊中国以外官方站提供销售并发货的海外购服务，您已经进行了以下授权：',
  AGREE_COLLECT_INFO:
    '同意amazon.cn收集并处理客户的姓名、地址、手机号码以及身份证信息或身份证复印件，以用于清关或为符合包括外汇管制在内的法律规定。',
  AGREE_ACCESS_CUSTOMER_INFO_OVER_SEA:
    '同意亚马逊海外购对应的境外销售实体Amazon Export Sales LLC获取客户亚马逊海外购账户的相关信息，以用于履行客户订单。',
  CANCEL_AUTH: '取消授权',
  RECOMMENDED_ASIN: '畅销推荐',
  CANCEL_AUTH_ALARM:
    '取消海外购客户授权，您将不能继续使用XXX账户购买海外购商品。',
  CONSENT_AUTHORIZATION: '同意授权',
  AUTHORIZE_SUCCESSFULLY: '成功授权',
  CANCEL_AUTH_SUCCESSFULLY: '取消授权成功',
  NOTIFICATION_REMINDER_SETTINGS: '消息通知设置',
  SYSTEM_MESSAGE_SETTINGS: '系统消息设置',
  ENABLED: '已开启',
  NOT_ENABLED: '未开启，去“设置”里打开',
  TURN_OFF_NOTIFICATION: '关闭消息通知',
  CLOSING_NOTIFICATION_REMIND:
    '关闭消息通知会影响您的购物体验，错过重要客服消息，实时订单包裹跟踪，和限时优惠促销通知。',
  CONTINUE_TO_CLOSE: '继续关闭',
  KEEP_MESSAGES_NOTIFICATIONS: '保留消息通知',
  CLIENT_SETTINGS_MODIFY_PUSH_STATUS:
    '请到客户端-设置-应用和服务-应用管理-通知管理，修改推送状态',
  PRIVACY_AND_SECURITY: '隐私与安全',
  PRIVACY_STATEMENT: '隐私声明',
  USE_CONDITION: '使用条件',
  USE_CONDITION_FOR_AGS: '亚马逊海外购使用条件',
  GET_MY_DATA: '获取我的数据',
  GET_ALL_DATA_AT_AMAZON: '获取我在亚马逊产生的所有数据',
  CANCEL_ACCOUNT: '注销账号',
  SETTING: '设置',
  MANAGE_ADDRESS: '管理地址信息',
  CLEARANCE_INFO: '清关信息',
  MANAGE_ID_CARD_INFORMATION: '管理身份证信息',
  GS_FOR_DOMESTIC_CUSTOMS_CLEARANCE: '海外购中用于国内清关使用',
  MESSAGE_REMINDER: '消息提醒设置',
  CURRENT_CACHE_USED_SPACE: '当前缓存已用空间',
  CLEAR_NOW: '立即清除',
  SUCCESSFULLY_CLEARED: '清除成功',
  ACCOUNT_SAFETY: '账户安全',
  CONFIRM_CLEAR_CACHE: '清除本地缓存',
  CONFIRM: '确定',
  CLEAR_CACHE: '清除缓存',
  LOGOUT_FROM_APP: '您正从当前设备退出亚马逊应用',
  LOGOUT: '退出登录',
  CONFIRM_LOGOUT: '确定退出登录',
  CONTACT_CS: '联系客服',
  GS_SHOPPING_PROCESS: '海外购流程',
  AMZ_CONTACT_ME: '亚马逊联系我',
  PLEASE_SELECT_ORDER: '请选择订单',
  ORDER_LIST: '订单列表',
  ORDER_NUMBER: '订单号',
  ORDER_TIME: '下单时间',
  TOTAL: '共',
  PIECE: '件',
  WE_WILL_CONTACT_YOU_LEAVE_YOUR_PHONE_NUMBER:
    '我们将立即联系您，请留下您的电话号码',
  PLEASE_ENTER_MOBILE_PHONE_NUMBER:
    '请按照标准格式输入11位中国大陆地区的手机号，如： 138 XXXX XXXX。',
  JUST_CLICK_THE_AMZ_CONTACT_ME: '点击“亚马逊联系我”按钮即可,该服务免费。',
  TELEPHONE_NUMBER: '电话号码',
  PLEASE_ENTER_YOUR_TELEPHONE_NUMBER: '请输入您的电话号码',
  CONNECTING: '连接中',
  CONNECTING_YOU_TO_A_SEAT: '请稍等，正在为您连接坐席',
  UNDER_SYSTEM_MAINTENANCE: '系统维护中',
  CONTACT_US_AT_THE_FOLLOWING_NUMBERS: '请拨打以下电话联系我们',
  PLEASE_CALL: '请拨打',
  NON_WORKING_HOURS: '非工作时间',
  WORKING_HOURS_OF_AMAZON: '亚马逊海外购客服工作时间：',
  EVERY_DAY: '每天',
  CHINA_TIME_ZONE: '中国时区',
  WELCOME_TO_CONTACT_US_DURING_WORKING_HOURS: '欢迎您在工作时间内联系我们，',
  WE_WILL_SOLVE_YOUR_PROBLEM: '我们会尽快为您解决问题',
  I_SEE: '我知道了',
  THE_FORMAT_OF_MOBILE_PHONE_NUMBER_IS_INCORRECT:
    '手机号码格式有误，请重新输入',
  NO_DATA: '暂无数据',
  NO_MORE: '没有更多了',
  TRANSACTION_NOTIFICATION: '交易通知',
  MESSAGE_CENTER: '消息中心',
  MARKED_READ: '全部已读',
  DELETE_MY_ACCOUNT: '注销我的账号',
  DELETE_ACCOUNT_IS_A_PERMANENT_OPERATION: '注销账号是永久性操作',
  REASON_FOR_DELETE_AMZN_ACCOUNT: '请选择注销亚马逊账号的原因',
  PLEASE_SELECT: '请选择',
  DELETE_MY_AMZN_ACCOUNT_AND_DELETE_MY_DATA:
    '我想永久注销我的亚马逊账号并删除我的数据',
  CONFIRM_TO_CANCEL_DELETE_ACCOUNT:
    '注销后会清空该账号的所有数据和信息且无法召回，您是否确定注销？',
  DELETE_REQUEST_CANNOT_BE_SUBMITTED:
    '您的注销亚马逊账号并删除数据的请求目前无法提交。请稍后重试。如果您仍遇到问题，请',
  CONTACT_US: '联系我们',
  PLEASE_SELECT_THE_REASON_FOR_DELETE_ACCOUNT: '请选择注销原因',
  SELECT_REASON_FOR_DELETE_ACCOUNT: '选择注销账号原因',
  CHECK_THE_TERMS_TO_CONFIRM: '请在页面底部勾选条款确认',
  APPLY_FOR_DELETE_ACCOUNT: '申请注销',
  SUBMITTED_SUCCESSFULLY: '提交成功',
  FAILED_TO_DELETE_AMZN_ACCOUNT: '注销亚马逊账号失败',
  NO_NEED_TO_CONFIRM_AGAIN: '您的申请已确认，无需重复确认',
  DELETE_ACCOUNT_REQUEST_SUBMITTED: '注销账号申请已提交',
  DELETE_ACCOUNT_CONFIRMATION_NOTIFICATION_REMINDER:
    '我们向您发送了确认通知链接。若需要继续执行注销账号操作，请查看您的短信。请通过短信确认执行注销账号的操作。请注意，确认链接将于发出5天后过期。',
  CANCEL_DELETE_AMZN_ACCOUNT: '取消注销亚马逊账号',
  YOUR_ACCOUNT_CAN_CONTINUE_TO_BE_USED_AFTER_CANCEL_DELETE:
    '取消注销账号后，您的账号将不会被注销，可以继续使用。',
  CANCEL_DELETE_ACCOUNT: '取消注销',
  CANCEL_DELETE_ACCOUNT_SUCCESSFULLY: '取消注销成功',
  PROCESSING_DELETE_ACCOUNT_REQUEST: '注销亚马逊账号的请求正在处理中',
  ALREADY_REVIEWED_REQUESTS_TO_DELETE_ACCOUNT_AND_DATA:
    '我们已审核您要求注销亚马逊账号并删除数据的请求。',
  IF_YOU_DO_NOT_WANT_TO_DELETE_YOUR_ACCOUNT_AND_DELETE_DATA:
    '如果您不想注销亚马逊账号并删除数据，请点击下面的“取消账号注销”。',
  TERMINATE_ACCOUNT_DELETE: '取消账号注销',
  TERMINATE_ACCOUNT_DELETE_SUCCESSFULLY: '取消账号注销成功',
  APPLY_TO_OBTAIN_MY_PERSONAL_DATA: '申请获取我的个人数据',
  PLEASE_SELECT_THE_DATA_I_WANT: '请选择我想要的数据',
  SUBMIT_APPLICATION: '提交申请',
  SUBMISSION_FAILED_PLEASE_RESUBMIT: '提交失败，请重新提交',
  SELECT_THE_DATA_I_WANT: '选择我想要的数据',
  DATA_REQUEST_CREATED: '数据请求创建',
  DATA_REQUEST_CONFIRMED: '数据请求确认',
  DATA_CONFIRMATION_EMAIL:
    '保护您的隐私和数据安全始终是亚马逊的第一要务。我们已向您的电子邮件发送了一个确认链接，您需要点击该链接以验证您的请求。请注意，此链接将在5天后过期。',
  CONFIRMATION_FAILED_PLEASE_RECONFIRM: '确认失败，请重新确认',
  DATA_ACQUISITION: '数据获取',
  DOWNLOAD_AMZN_DATA:
    '保护您的隐私和数据安全始终是亚马逊的第一要务。您可以下载您的亚马逊数据，数据将在XXX天后过期。',
  YOUR_DATA_WILL_EXPIRE: '您的数据将于XXX过期。',
  DOWNLOAD_DATA: '下载数据',
  FILE_IS_OUT_OF_DATE: '文件已过期',
  SYSTEM_TIMEOUT_TRY_AGAIN_LATER: '系统超时,请稍后重试',
  NO_CACHE_TO_CLEAR: '暂无可清除的缓存'
};
